// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconForkKnife = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M19.035 3v17h-2v-4.857H16l-1-1V6a3 3 0 013-3zM4 4v4a4 4 0 003 3.874V20h2v-8.126c1.725-.444 3-2.01 3-3.874V4h-2v4a2 2 0 01-1 1.732V4H7v5.732A2 2 0 016 8V4z" />
  );
export default SvgIconForkKnife;
